import PropTypes from 'prop-types'
import { View } from './View'

/**
 * IBAの独自コンポーネントです
 */
export const TextButton = ({ ...props }) => {
    return <View {...props} />
}

TextButton.propTypes = {
    /**
     * 要素の幅
     */
    width: PropTypes.number,
    /**
     * フォントサイズ
     */
    fontSize: PropTypes.number,
    /**
     * コンテンツ
     */
    children: PropTypes.node,
    /**
     * ボタンクリック時に発火<br>
     * (event: React.SyntheticEvent) => void
     */
    onClick: PropTypes.func,
    /**
     * disabled
     */
    disabled: PropTypes.bool,
    /**
     * button タグの type 属性
     */
    type: PropTypes.oneOf(['button', 'submit']),
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

TextButton.defaultProps = {
    type: 'button'
}
